/* global google */

import jQuery from 'jquery';
import escape from 'lodash/escape';
import invokeMap from 'lodash/invokeMap';
import size from 'lodash/size';
import EventService from '../../common/event/EventService';
import SystemListEvent from '../../vcom/events/SystemListEvent';
import UpdateServiceEvent from '../../vcom/events/UpdateServiceEvent';
import PortletEvent from '../../vcom/events/PortletEvent';
import VcomProvider from '../../VcomProvider';
import VcomSection from '../../vcom/const/VcomSection';
import translate from '../../common/localization/translate';
import Base from '../../vcom/Base';

export default function GoogleMapController(idUpdateContainer) {
  let gmap;
  this.idUpdateContainer = idUpdateContainer;
  this.elPortlet = jQuery(`#${idUpdateContainer}`).parent();
  this.markers = {};
  this.anlagen = {};

  const that = this;
  const infowindow = new google.maps.InfoWindow({
    size: new google.maps.Size(50, 50),
  });
  const aMarkers = [];

  const refreshStatus = function refreshStatus(systemList) {
    if (!systemList || systemList.length <= 0) {
      return;
    }
    const anlagenIds = Object.values(systemList)
      .map((system) => system.id);
    aMarkers.forEach((marker) => {
      if (anlagenIds.indexOf(marker.anlagenId) >= 0) {
        if (Object.prototype.hasOwnProperty.call(systemList[marker.anlagenId], 'status')) {
          const { status } = systemList[marker.anlagenId];
          marker.setIcon(that.greenIcon);
          if (status < 100) {
            marker.setIcon(that.orangeIcon);
          } else if (status >= 200) {
            marker.setIcon(that.greyIcon);
          }
        } else {
          marker.setIcon(that.blueIcon);
        }
        marker.setVisible(true);
      } else {
        marker.setVisible(false);
      }
    });

    anlagenIds.forEach((anlagenId) => {
      if (!Object.prototype.hasOwnProperty.call(that.anlagen, anlagenId)) {
        that.addMarker(anlagenId, systemList[anlagenId]);
      }
    });

    that.fitMapToBounds(aMarkers);
  };

  that.resizePortlet = function resize(event) {
    event.preventDefault();
    that.resize();
  };

  that.refreshSystemList = function refreshSystemList(event) {
    refreshStatus(event.detail.systemList);
  };

  that.panToSystemWithId = function panToSystemWithId(event) {
    that.panToAnlage(event.detail.id);
  };

  that.closeInfoWindow = function closeInfoWindow() {
    infowindow.close();
  };

  that.setMapOptions = function setMapOptions() {
    gmap.setOptions({
      styles: that.getMapStyle(),
    });
  };

  that.onDestroy = function onDestroy() {
    EventService.removeListener(SystemListEvent.CHANGED, { callback: that.refreshSystemList });
    EventService.removeListener(SystemListEvent.FILTER_CHANGED, { callback: that.closeInfoWindow });
    EventService.removeListener(UpdateServiceEvent.RECEIVED, { callback: that.setMapOptions });
    EventService.removeListener(
      SystemListEvent.SYSTEM_DESELECTED,
      { callback: that.closeInfoWindow },
    );
    EventService.removeListener(
      SystemListEvent.SYSTEM_SELECTED,
      { callback: that.panToSystemWithId },
    );
  };

  this.init = function init() {
    jQuery(`#${this.idUpdateContainer}`)
      .height(this.elPortlet.height())
      .width(this.elPortlet.width());

    const mapOptions = this.getDefaultMapOptions();
    mapOptions.styles = this.getMapStyle();
    gmap = new google.maps.Map(
      jQuery(`#${this.idUpdateContainer}`).get(0),
      mapOptions,
    );

    const zoomControlsDiv = document.createElement('div');
    this.createCustomZoomControls(zoomControlsDiv, gmap);
    gmap.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(zoomControlsDiv);

    const mapTypeControlsDiv = document.createElement('div');
    this.createCustomMapTypeControls(mapTypeControlsDiv, gmap);
    gmap.controls[google.maps.ControlPosition.LEFT_TOP].push(mapTypeControlsDiv);

    this.prepareMarkers();
    this.generateMarkers();

    google.maps.event.addListenerOnce(gmap, 'idle', () => {
      if (size(that.anlagen) === 1) {
        gmap.setZoom(10);
      }
      if (VcomProvider.systemId !== null) {
        that.panToAnlage(VcomProvider.systemId);
      }
    });

    jQuery(that.elPortlet)
      .on('onDestroy', that.onDestroy);

    EventService.addListener(PortletEvent.RESIZE_STOPPED, {
      callback: that.resizePortlet,
      target: that.elPortlet[0],
    });
    EventService.addListener(SystemListEvent.CHANGED, { callback: that.refreshSystemList });
    EventService.addListener(SystemListEvent.FILTER_CHANGED, { callback: that.closeInfoWindow });
    EventService.addListener(SystemListEvent.SYSTEM_DESELECTED, { callback: that.closeInfoWindow });
    EventService.addListener(SystemListEvent.SYSTEM_SELECTED, { callback: that.panToSystemWithId });
    EventService.addListener(UpdateServiceEvent.RECEIVED, { callback: that.setMapOptions });
  };

  this.getMapStyle = function getMapStyle() {
    if (VcomProvider.Layout.getTheme() === 'darkify') {
      return this.getStyleForDarkify();
    }
    return [];
  };

  this.createCustomZoomControls = function createCustomZoomControls(controlDiv, googlemap) {
    const zoomInControlUI = document.createElement('button');
    const zoomOutControlUI = document.createElement('button');
    const zoomControls = [zoomInControlUI, zoomOutControlUI];
    const buttonClasses = ['btn', 'btn-secondary', 'btn-sm'];

    zoomInControlUI.innerHTML = '&plus;';
    zoomInControlUI.title = translate('googleMap.ZOOM_IN');
    zoomOutControlUI.innerHTML = '&minus;';
    zoomOutControlUI.title = translate('googleMap.ZOOM_OUT');

    zoomControls.forEach((zoomControl) => {
      zoomControl.classList.add(...buttonClasses);
      controlDiv.appendChild(zoomControl);
    });

    google.maps.event.addDomListener(zoomInControlUI, 'click', () => googlemap.setZoom(googlemap.getZoom() + 1));
    google.maps.event.addDomListener(zoomOutControlUI, 'click', () => googlemap.setZoom(googlemap.getZoom() - 1));
  };

  this.createCustomMapTypeControls = function createCustomMapTypeControls(
    mapTypeControlsDiv,
    googlemap,
  ) {
    const buttonClasses = ['btn', 'btn-secondary', 'btn-sm', 'dropdown-toggle'];
    const menuClasses = ['dropdown-menu', 'ui-menu', 'ui-widget', 'ui-widget-content',
      'control-options-menu', 'map-type-options-menu', 'invisible'];
    const mapTypeOptionClasses = ['ui-corner-all', 'clickable', 'map-type-label', 'dropdown-item'];
    const checkBoxClasses = ['ui-corner-all', 'map-type-checkbox', 'clickable', 'ml-1'];

    const mapTypeControlSelectButton = document.createElement('button');
    mapTypeControlSelectButton.classList.add(...buttonClasses);
    mapTypeControlSelectButton.title = translate('googleMap.CHANGE_MAP_TYPE');

    const selectText = document.createElement('span');
    selectText.id = 'map-type-display';
    selectText.innerText = translate('googleMap.MAP');
    mapTypeControlSelectButton.appendChild(selectText);

    const mapTypeOptionsDiv = document.createElement('div');
    mapTypeOptionsDiv.classList.add(...menuClasses);
    mapTypeOptionsDiv.id = 'map-type-options';

    const mapOption = this.createMapTypeOption(
      translate('googleMap.MAP'),
      translate('googleMap.SHOW_CITY_MAP'),
      mapTypeOptionClasses,
    );

    const satelliteOption = this.createMapTypeOption(
      translate('googleMap.SATELLITE'),
      translate('googleMap.SHOW_SATELLITE_IMAGERY'),
      mapTypeOptionClasses,
    );

    const terrainDiv = this.createCheckboxDiv(
      'terrain',
      translate('googleMap.TERRAIN'),
      translate('googleMap.SHOW_CITY_MAP_WITH_TERRAIN'),
      checkBoxClasses,
    );
    const captionsDiv = this.createCheckboxDiv(
      'captions',
      translate('googleMap.CAPTIONS'),
      translate('googleMap.SHOW_SATELLITE_IMAGES_WITH_STREETNAMES'),
      checkBoxClasses,
    );
    captionsDiv.classList.add('d-none');

    const horizontalLine = document.createElement('hr');
    horizontalLine.classList.add('m-1');

    const mapTypeOptions = [mapOption, satelliteOption, horizontalLine, terrainDiv, captionsDiv];
    mapTypeOptions.forEach((mapTypeOption) => {
      mapTypeOptionsDiv.appendChild(mapTypeOption);
    });

    google.maps.event.addDomListener(mapTypeControlSelectButton, 'click', (event) => {
      const menu = jQuery('#map-type-options');
      event.stopPropagation();
      if (menu.hasClass('invisible')) {
        menu.removeClass('invisible');
        menu.show();
        return;
      }
      if (menu.is(':hidden')) {
        menu.show();
      } else {
        menu.hide();
      }
    });

    jQuery(document)
      .on('click', () => {
        jQuery('#map-type-options').hide();
      });

    google.maps.event.addDomListener(satelliteOption, 'click', (event) => {
      this.showSatelliteTypeCheckbox();
      jQuery('#map-type-display').text(translate('googleMap.SATELLITE'));
      this.handleSatelliteTypeToggle(googlemap);
      event.stopPropagation();
    });

    google.maps.event.addDomListener(mapOption, 'click', (event) => {
      this.showMapTypeCheckbox();
      jQuery('#map-type-display').text(translate('googleMap.MAP'));
      this.handleMapTypeToggle(googlemap);
      event.stopPropagation();
    });

    google.maps.event.addDomListener(captionsDiv, 'click', (event) => {
      this.handleSatelliteTypeToggle(googlemap);
      event.stopPropagation();
    });

    google.maps.event.addDomListener(terrainDiv, 'click', (event) => {
      this.handleMapTypeToggle(googlemap);
      event.stopPropagation();
    });

    mapTypeControlsDiv.appendChild(mapTypeControlSelectButton);
    mapTypeControlsDiv.appendChild(mapTypeOptionsDiv);
    mapTypeControlsDiv.classList.add('mt-1', 'ml-1');
  };

  this.createMapTypeOption = function createMapTypeOption(text, title, classList) {
    const optionContent = document.createElement('a');
    optionContent.text = text;
    optionContent.title = title;
    optionContent.classList.add(...classList);
    return optionContent;
  };

  this.createCheckboxDiv = function createCheckboxDiv(type, text, title, classList) {
    const checkboxDiv = document.createElement('li');
    checkboxDiv.id = type.concat('-div');
    checkboxDiv.title = title;
    checkboxDiv.classList.add('pt-1');

    const checkbox = document.createElement('input');
    checkbox.id = type.concat('-checkbox');
    checkbox.type = 'checkbox';
    checkbox.classList.add(...classList);
    checkbox.checked = true;

    const label = document.createElement('label');
    label.innerText = text;
    label.classList.add('map-type-label', 'clickable');
    label.setAttribute('for', type.concat('-checkbox'));

    checkboxDiv.appendChild(checkbox);
    checkboxDiv.appendChild(label);
    return checkboxDiv;
  };

  this.handleMapTypeToggle = function handleMapTypeToggle(googlemap) {
    if (jQuery('#terrain-checkbox')[0].checked) {
      googlemap.setMapTypeId('terrain');
    } else {
      googlemap.setMapTypeId('roadmap');
    }
  };

  this.handleSatelliteTypeToggle = function handleSatelliteTypeToggle(googlemap) {
    if (jQuery('#captions-checkbox')[0].checked) {
      googlemap.setMapTypeId('hybrid');
    } else {
      googlemap.setMapTypeId('satellite');
    }
  };

  this.showSatelliteTypeCheckbox = function showSatelliteTypeCheckbox() {
    jQuery('#captions-div').removeClass('d-none');
    jQuery('#terrain-div').addClass('d-none');
  };

  this.showMapTypeCheckbox = function showMapTypeCheckbox() {
    jQuery('#captions-div').addClass('d-none');
    jQuery('#terrain-div').removeClass('d-none');
  };

  this.prepareMarkers = function prepareMarkers() {
    this.greenIcon = new google.maps.MarkerImage(
      `${VcomProvider.baseUrl}/images/gmaps/image_green.png`,
      new google.maps.Size(10, 10),
      new google.maps.Point(0, 0),
      new google.maps.Point(5, 10),
    );
    this.orangeIcon = new google.maps.MarkerImage(
      `${VcomProvider.baseUrl}/images/gmaps/image_orange.png`,
      new google.maps.Size(10, 10),
      new google.maps.Point(0, 0),
      new google.maps.Point(5, 10),
    );
    this.greyIcon = new google.maps.MarkerImage(
      `${VcomProvider.baseUrl}/images/gmaps/image_grey.png`,
      new google.maps.Size(10, 10),
      new google.maps.Point(0, 0),
      new google.maps.Point(5, 10),
    );
    this.blueIcon = new google.maps.MarkerImage(
      `${VcomProvider.baseUrl}/images/gmaps/image_blue.png`,
      new google.maps.Size(10, 10),
      new google.maps.Point(0, 0),
      new google.maps.Point(5, 10),
    );
    this.shape = {
      coord: [7, 0, 8, 1, 9, 2, 9, 3, 9, 4, 9, 5, 9, 6, 9, 7, 8, 8, 7, 9, 2, 9, 1, 8, 0, 7, 0, 6, 0,
        5, 0, 4, 0, 3, 0, 2, 1, 1, 2, 0, 7, 0],
      type: 'poly',
    };
  };

  this.generateMarkers = function generateMarkers() {
    Base.getSystems().done((systems) => {
      that.anlagen = systems;

      if (aMarkers) {
        invokeMap(aMarkers, 'setMap', null);
        that.aMarkers = [];
        that.markers = {};
      }

      jQuery.each(that.anlagen, (key, system) => {
        that.addMarker(system.id, system);
      });

      that.fitMapToBounds(aMarkers);
    });
  };

  this.addMarker = function addMarker(anlagenId, anlage) {
    if (!Object.prototype.hasOwnProperty.call(that.anlagen, anlagenId)) {
      that.anlagen[anlagenId] = anlage;
    }
    const point = new google.maps.LatLng(anlage.lat, anlage.lon);
    const markerOptions = that.getDefaultMarkerOptions();
    if (anlage.status < 100) {
      markerOptions.icon = that.orangeIcon;
    } else if (this.status >= 200) {
      markerOptions.icon = that.greyIcon;
    }
    markerOptions.position = point;
    markerOptions.title = that.anlagen[anlagenId].label;

    const marker = new google.maps.Marker(markerOptions);

    marker.setMap(gmap);
    marker.anlagenId = anlagenId;
    google.maps.event.addListener(marker, 'click', () => {
      if (VcomProvider.section === VcomSection.COCKPIT) {
        that.panToMarker(marker, anlagenId);
        return;
      }
      EventService.dispatch(SystemListEvent.SYSTEM_SELECTED, {
        data: {
          id: anlagenId,
          systemName: that.anlagen[anlagenId].label,
        },
      });
    });
    that.markers[anlagenId] = marker;
    aMarkers.push(marker);
  };

  this.panToMarker = function panToMarker(marker, anlage) {
    infowindow.close();
    gmap.setZoom(10);
    google.maps.event.addListenerOnce(gmap, 'bounds_changed', () => {
      let content = that.createCockpitLink(that.anlagen[anlage]);
      if (Object.prototype.hasOwnProperty.call(that.anlagen[anlage], 'status')) {
        let msg = 'No Alarms present';
        if (that.anlagen[anlage].status <= 25) {
          msg = 'Open Alarms (serious)';
        } else if (that.anlagen[anlage].status <= 75) {
          msg = 'Open Alarms';
        } else if (that.anlagen[anlage].status >= 200) {
          msg = 'Alarms (in process)';
        }
        content += `<br><small>${msg}</small>`;
      }
      infowindow.setContent(content);
      infowindow.open(gmap, marker);
    });
    gmap.panTo(marker.getPosition());
  };

  this.createCockpitLink = function createCockpitLink(system) {
    const url = `${VcomProvider.baseUrl}/default/cockpit/index/systemId/${system.id}`;
    // seems like map can't set width automatically... @see https://code.google.com/p/gmaps-api-issues/issues/detail?id=5713
    const width = Math.round((0.5 * system.label.length) + 0.5);
    return `<div style="overflow: hidden;min-width: ${width}em"><b><a href="${url}">${escape(system.label)}</a></b></div>`;
  };

  this.panToAnlage = function panToAnlage(systemId) {
    jQuery.each(this.anlagen, (key, system) => {
      if (system.id === systemId) {
        that.panToMarker(that.markers[key], system.id);
      }
    });
  };

  this.resize = function resize() {
    jQuery(`#${this.idUpdateContainer}`)
      .height(this.elPortlet.height())
      .width(this.elPortlet.width());
    google.maps.event.trigger(gmap, 'resize');
  };

  this.getDefaultMapOptions = function getDefaultMapOptions() {
    const defaultMapOptions = {
      backgroundColor: 'transparent',
      center: new google.maps.LatLng(48.4, 10.9),
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.TERRAIN,
      panControl: true,
      scaleControl: true,
      zoom: 4,
    };
    return defaultMapOptions;
  };

  this.getDefaultMarkerOptions = function getDefaultMarkerOptions() {
    const defaultMarkerOptions = {
      clickable: true,
      draggable: false,
      icon: this.greenIcon,
      shape: this.shape,
    };
    return defaultMarkerOptions;
  };

  this.fitMapToBounds = function fitMapToBounds(markers) {
    if (markers.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      jQuery.each(markers, (key, marker) => {
        if ((!marker.getVisible()) || marker.getMap() == null) {
          return;
        }
        bounds.extend(marker.position);
      });
      gmap.fitBounds(bounds);
      if (gmap.getZoom() > 15) {
        gmap.setZoom(12);
      }
    }
  };

  this.getStyleForDarkify = function getStyleForDarkify() {
    return [
      {
        stylers: [
          {
            hue: '#ff1a00',
          },
          {
            invert_lightness: true,
          },
          {
            saturation: -100,
          },
          {
            lightness: 33,
          },
          {
            gamma: 0.5,
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#2d333c',
          },
        ],
      },
    ];
  };
}
